module.exports = __webpack_public_path__ + "static/media/71-attic.530a7f93.jpg";